export class Model {
  Id: number;
  ManufacturerId: number;
  ManufacturerName:string;
  Name: string;
  Type: number;
  Ma: number;
  Tcfa: number;
  Tcfb: number;
  IsActive: number;
  CreatedAt: string;
  UpdatedAt: string;
}
